import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { pmApi } from '../../api/pm.js';
import { useAuth } from '../../contexts/AuthContext.jsx';

export default function ProjectHub() {
  const { can } = useAuth();
  const [projects, setProjects] = useState([]);
  const [workspaces, setWorkspaces] = useState([]);
  const [showForm, setShowForm] = useState(false);

  function refresh() { pmApi.projects().then((d) => setProjects(d?.items || [])); }
  useEffect(refresh, []);
  useEffect(() => { pmApi.workspaces().then((d) => setWorkspaces(d?.items || [])); }, []);

  async function submit(e) {
    e.preventDefault();
    const fd = new FormData(e.currentTarget);
    await pmApi.createProject({
      workspaceId: fd.get('workspaceId'),
      name: fd.get('name'),
      key: fd.get('key').toUpperCase(),
      description: fd.get('description') || null,
    });
    e.currentTarget.reset();
    setShowForm(false);
    refresh();
  }

  return (
    <section>
      <header className="page-header">
        <h1>Projects</h1>
        {can('project', 'create') && <button className="btn primary" onClick={() => setShowForm((s) => !s)}>{showForm ? 'Close' : '+ New Project'}</button>}
      </header>
      {showForm && (
        <form onSubmit={submit} className="card form-card grid-form">
          <label>Workspace
            <select name="workspaceId" required>
              <option value="">Select…</option>
              {workspaces.map((w) => <option key={w.id} value={w.id}>{w.name}</option>)}
            </select>
          </label>
          <label>Name<input name="name" required /></label>
          <label>Key<input name="key" required pattern="[A-Z][A-Z0-9]*" placeholder="e.g. BOS" /></label>
          <label className="full">Description<input name="description" /></label>
          <div className="full actions"><button className="btn primary" type="submit">Create</button></div>
        </form>
      )}
      <div className="card-grid">
        {projects.map((p) => (
          <Link key={p.id} to={`/pm/projects/${p.key}/board`} className="project-card">
            <div className="proj-key">{p.key}</div>
            <div className="proj-name">{p.name}</div>
            <p className="muted small">{p.description || '—'}</p>
            <div className="proj-stats">
              <ProgressRing percent={p.progress} />
              <div>
                <div><strong>{p.issue_count - p.done_count}</strong> open</div>
                <div className="muted small">{p.issue_count} total · {p.done_count} done</div>
              </div>
            </div>
          </Link>
        ))}
        {projects.length === 0 && <div className="muted">No projects yet — create one to get started.</div>}
      </div>
    </section>
  );
}

function ProgressRing({ percent = 0 }) {
  const r = 22;
  const c = 2 * Math.PI * r;
  const offset = c * (1 - percent / 100);
  return (
    <svg width="56" height="56" viewBox="0 0 56 56">
      <circle cx="28" cy="28" r={r} stroke="#e2e8f0" strokeWidth="6" fill="none" />
      <circle
        cx="28" cy="28" r={r}
        stroke="#2563eb" strokeWidth="6" fill="none"
        strokeDasharray={c} strokeDashoffset={offset}
        transform="rotate(-90 28 28)" strokeLinecap="round"
      />
      <text x="28" y="33" textAnchor="middle" fontSize="13" fontWeight="700" fill="#0f172a">{percent}%</text>
    </svg>
  );
}
